import React, { Suspense, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect, Provider, useDispatch } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { CustomProvider } from '@leegality/leegality-react-component-library';
import './app.scss';
import configureStore from '../store/configure-store';
import TranslationsContext from '../store/translations-context';
import InitialReducers from './reducers';
import { appMounted } from './actions/app-actions';
import appRoutes from '../constants/app-routes';
import Loading from '../components/views/loading';
import { NotificationBase } from '../components/views/notification/notification';
import { resetRouting } from './reducers/routing-reducer';
import SafeRedirect from '../components/views/safe-redirect';

const mapState = (reducers) => (reducers);

const App = ({ redirect, routing, translations }) => {
  const dispatch = useDispatch();

  const handleRedirectCleanUp = useCallback(() => {
    dispatch(resetRouting());
  }, []);

  return (
    <>
      <SafeRedirect path={routing.redirectTo} onCleanUp={handleRedirectCleanUp} />
      <TranslationsContext.Provider value={translations}>
        <CustomProvider locale={redirect.selectedLocale}>
          <NotificationBase />
          <Suspense fallback={<Loading />}>
            {useRoutes(appRoutes)}
          </Suspense>
        </CustomProvider>
      </TranslationsContext.Provider>
    </>
  );
};

App.propTypes = {
  routing: PropTypes.instanceOf(Object),
  redirect: PropTypes.instanceOf(Object),
  translations: PropTypes.instanceOf(Object),
};

App.defaultProps = {
  routing: {},
  redirect: {},
  translations: {},
};

const ConnectedApp = connect(mapState, () => ({}))(App);

const render = (user) => {
  const store = configureStore({ user }, InitialReducers);
  store.dispatch(appMounted());

  return (
    <Provider store={store}>
      <ConnectedApp />
    </Provider>
  );
};

export default render;
